exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coins .coin{width:320px;height:260px;background:url(\"https://d2rzfffph148bz.cloudfront.net/web_store/images/desktop/web_pc_coins_bg.png\") bottom no-repeat}.coins .coin .permissions .loyalty{margin-left:12px}.coins .coin .permissions .loyalty>div{position:absolute;top:5%}.coins .coin .permissions .loyalty .icon-loyalty,.coins .coin .permissions .loyalty .loyalty-points{flex:0 0 auto}.mobile .coins .coin{background:url(\"https://d2rzfffph148bz.cloudfront.net/web_store/images/common/coins_icon/web_phone_coins_bg.png\") bottom no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47532c25","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/coins.vue
// module id = 426
// module chunks = 0